module.exports = __webpack_public_path__ + "img/扫码点单.b1924af3.png";